import { getCaseStatus } from '../api/getCaseStatus';
import { getItem, setItem } from './storage';

export const setPublicSPID = async ({ uuid }) => {
  try {
    if (!uuid) return;
    const caseStatus = await getCaseStatus({ uuid });

    if (caseStatus) {
      setItem('public_spid', caseStatus?.publicSPID);
    }
  } catch (error) {
    console.log({ error });
  }
};

export const getPublicSPID = () => getItem('public_spid');
